import React, { useEffect } from 'react';

interface PreviewImageModalProps {
  src: string | null | undefined;
  alt?: string;
  open: boolean;
  onClose: () => void;
}

const backdropStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.65)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  padding: '24px',
};

const modalStyle: React.CSSProperties = {
  position: 'relative',
  maxWidth: '96vw',
  maxHeight: '90vh',
  background: '#111',
  borderRadius: 8,
  boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
  overflow: 'hidden',
};

const imgStyle: React.CSSProperties = {
  maxWidth: '96vw',
  maxHeight: '90vh',
  display: 'block',
  objectFit: 'contain',
};

const closeBtnStyle: React.CSSProperties = {
  position: 'absolute',
  top: 8,
  right: 8,
  background: 'rgba(0,0,0,0.6)',
  color: 'white',
  border: 'none',
  borderRadius: 6,
  padding: '6px 10px',
  cursor: 'pointer',
};

const topBarStyle: React.CSSProperties = {
  position: 'absolute',
  top: 8,
  left: 8,
  display: 'flex',
  gap: 8,
};

const linkBtnStyle: React.CSSProperties = {
  background: 'rgba(255,255,255,0.1)',
  color: 'white',
  border: '1px solid rgba(255,255,255,0.25)',
  borderRadius: 6,
  padding: '6px 10px',
  textDecoration: 'none',
  fontSize: 12,
};

const PreviewImageModal: React.FC<PreviewImageModalProps> = ({ src, alt, open, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = originalOverflow;
    };
  }, [open, onClose]);

  if (!open || !src) return null;

  const stop: React.MouseEventHandler<HTMLDivElement> = (e) => e.stopPropagation();

  return (
    <div style={backdropStyle} onClick={onClose} role="dialog" aria-modal="true">
      <div style={modalStyle} onClick={stop}>
        <div style={topBarStyle}>
          <a href={src} target="_blank" rel="noreferrer" style={linkBtnStyle}>
            Open in new tab
          </a>
          <a href={src} download style={linkBtnStyle}>
            Download
          </a>
        </div>
        <button onClick={onClose} aria-label="Close preview" style={closeBtnStyle}>
          ✕
        </button>
        <img src={src} alt={alt || 'Preview'} style={imgStyle} />
      </div>
    </div>
  );
};

export default PreviewImageModal;
